import React, { useEffect, useState } from 'react';
import TopNavbar from '../../components/Nav/TopNavbar';
import Footer from '../../components/Sections/Footer/Footer';
import serviceBanner from '../../assets/serviceBanner.gif';
import BookaScreenHeroContainer from '../../assets/BookaScreen/BookaScreenHeroContainer.png';
import wave3 from '../../assets/BookaScreen/Wave3.png';
import wave2 from '../../assets/BookaScreen/Wave2.png';
import alrazi from '../../assets/BookaScreen/al-razi.jpg';
import alFarabi from '../../assets/BookaScreen/al-farabi.jpg';
import alkhawarzmi from '../../assets/BookaScreen/al-khawarizmi.jpg';
import alkindi from '../../assets/BookaScreen/al-kindi.jpg';
import Plantation_u from '../../assets/BookaScreen/Plantation_u.png';

import wifi from '../../assets/BookaScreen/wifi.png'
import tech from '../../assets/BookaScreen/high tech learning.png'
import pray from '../../assets/BookaScreen/prayer area.png'
import glowimg1 from '../../assets/BookaScreen/Glowimg1.png'
import Slider from "react-slick";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './style.module.css'
import style from "./style.module.css";
import videoOne from '../../assets/video/video1.mp4'
import videoTwo from '../../assets/video/video2.mp4'
import videoThree from '../../assets/video/video3.mp4'
import { BookaRoomForm } from './BookaRoomForm';
import videoFour from '../../assets/video/video4.mp4'
import videoFive from '../../assets/video/video5.mp4'
import videoSix from '../../assets/video/video6.mp4'
import WeD6 from '../../assets/WhatWeDo/WeD6.png'
import servicegradient from '../../assets/WhatWeDo/servicegradient.png'
import randomline from '../../assets/WhatWeDo/randomline.png'
import serviceWave from '../../assets/serviceWave.png'
import serviceWave2 from '../../assets/serviceWave2.png'
import nounrecruitment from '../../assets/BookaScreen/noun-recruitment.png';
import Learning from '../../assets/BookaScreen/Learning.png';
import Employee from '../../assets/BookaScreen/Employee.png';
import Trowel from '../../assets/BookaScreen/Trowel.png';
import Consultant from '../../assets/BookaScreen/Consultant.png';
import staffoutsourcing from '../../assets/BookaScreen/staffoutsourcing.svg';
import recrumentsearch from '../../assets/BookaScreen/recrumentsearch.svg';
import payrollprocessing from '../../assets/BookaScreen/payrollprocessing.svg';
import cplacement from '../../assets/BookaScreen/cplacement.svg';
import employeevetting from '../../assets/BookaScreen/employeevetting.svg';
import network_opportunities from '../../assets/BookaScreen/network_opportunities.svg';
import profile from '../../assets/BookaScreen/profile.png';
import profile1 from '../../assets/BookaScreen/profile1.png';
import profile2 from '../../assets/BookaScreen/profile2.png';
import profile3 from '../../assets/BookaScreen/profile3.png';
import profile4 from '../../assets/BookaScreen/profile4.png';
import profile5 from '../../assets/BookaScreen/profile5.png';
import profile6 from '../../assets/BookaScreen/profile6.png';
import profile7 from '../../assets/BookaScreen/profile7.png';
import profile8 from '../../assets/BookaScreen/profile8.png';
import Imgpsh from '../../assets/BookaScreen/Imgpsh.jpg';
import { Fade } from 'react-reveal';
import { useNavigate } from 'react-router-dom';


const services = [
    {
        imgSrc:cplacement,
        title: "C-suit Placement Services",
        description:
            "We connect you with the right talent through a streamlined recruitment process, prioritizing fit, skill, and potential for long-term success.",
    },
    {
        imgSrc: recrumentsearch,
        title: "Recruitment Search",
        description:
            "Boost your team’s potential with customized training and coaching, from executive leadership development to essential skills for employees at all levels.",
    },
    {
        imgSrc: staffoutsourcing,
        title: "Staff outsourcing",
        description:
            "Stay compliant with local and international regulations, reducing risk and ensuring your business operates smoothly, legally, and ethically.",
    },
    {
        imgSrc: payrollprocessing,
        title: "Payroll Processing",
        description:
            "Simplify payroll with accurate, efficient processing that ensures timely, precise payments, so you can focus on growing your business.",
    },
    {
        imgSrc: network_opportunities ,
        title: "Network Opportunities",
        description:
            "At Talent Expertz HR solutions we believe in the power of networking and knowledge sharing to drive industry innovation and growth.",
    },
    {
        imgSrc: employeevetting ,
        title: "Employee Engagement",
        description:
            "Create a workplace where employees feel valued and motivated, fostering an inclusive culture that boosts retention and productivity.",
    },
];

const sliderData = [
    {
        id: 1,
        imgSrc: profile5,
        name: "Adeel Ahmed",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "08:21 PM - Jan 4, 2024",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/adeel-ahmed-1842b6315?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        id: 2,
        imgSrc: profile1,
        name: "Mahnoor Khan",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "01:10 PM - March 23, 2024",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/mahnoor-khan-8143722a2/"
    },
    {
        id: 3,
        imgSrc: profile6,
        name: "Muhammad Ibrahim",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? ",
        date: "05:50 PM - Jan 15, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/muhammad-ibrahim-505b13235/"
    },
    {

        id: 4,

        imgSrc: profile2,
        name: "Tehreem Fatima",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "03:30 PM - Dec 4, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/tehreem-fatimaa/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    }

    ,
    {
        id: 5,

        imgSrc: profile7,
        name: "Tehreem Fatima",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "03:30 PM - Dec 4, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/tehreem-fatimaa/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        id: 6,

        imgSrc: profile3,
        name: "sana",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "03:30 PM - Dec 4, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/tehreem-fatimaa/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        id: 7,

        imgSrc: profile8,
        name: "osama",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "03:30 PM - Dec 4, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/tehreem-fatimaa/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        id: 8,

        imgSrc: profile4,
        name: "Fatima",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "03:30 PM - Dec 4, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/tehreem-fatimaa/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    }
];

const slider2Data = [
    // {
    //   imgSrc: Zikria,
    //   name: "Muhammad Zikria",
    //   title: "Student",
    //   text: "Enrolling in AshreiTech Academy has been one of the most rewarding decisions I've ever made. Even though I'm not paying for my education here, I've been given the same level of attention and support as if I had invested a substantial amount for my training.",
    //   date: "08:21 PM - Jan 4, 2023",
    //   rating: 4,
    //   linkedinUrl: "https://www.linkedin.com/in/syed-muhammad-zikria-zikria-781bb8132/"
    // },
    // {
    //   imgSrc: Bilal,
    //   name: "Bilal Asif Mangi",
    //   title: "Student",
    //   text: "The faculty at AshreiTech Academy is professional and encouraging. I highly recommend visiting the academy and enrolling in their courses.",
    //   date: "08:21 PM - Jan 4, 2023",
    //   rating: 4,
    //   linkedinUrl: "https://www.linkedin.com/in/bilal-asif-mangi-40b183223/"
    // },
    {
        imgSrc: profile,
        name: "zain",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "08:21 PM - Jan 4, 2024",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/adeel-ahmed-1842b6315?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    },
    {
        imgSrc: profile,
        name: "zain",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "01:10 PM - March 23, 2024",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/mahnoor-khan-8143722a2/"
    },
    {
        imgSrc: profile,
        name: "zain",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? I now feel well-prepared for my career in procurement, thanks to AshreiTech Academy.",
        date: "05:50 PM - Jan 15, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/muhammad-ibrahim-505b13235/"
    },
    {
        imgSrc: profile,
        name: "zain",
        title: "Student",
        text: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse? Lorem ipsum dolor sit amet consectetur adipisicing elit. Iste ducimus vitae commodi libero nam sed esse?",
        date: "03:30 PM - Dec 4, 2023",
        rating: 4,
        linkedinUrl: "https://www.linkedin.com/in/tehreem-fatimaa/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
    }
];

export default function Services() {
    const navigate = useNavigate();
    const [data, setdata] = useState(sliderData)
    const [card1Data, setcard1Data] = useState(sliderData[0])
    const [card2Data, setcard2Data] = useState(sliderData[2])
    const [card3Data, setcard3Data] = useState(sliderData[4])
    const [card4Data, setcard4Data] = useState(sliderData[5])


    useEffect(() => {
        const interval = setInterval(() => {
            setcard1Data((prevData) => prevData.id === card1Data.id ? sliderData[1] : sliderData[0])
            setcard2Data((prevData) => prevData.id === card2Data.id ? sliderData[3] : sliderData[2])
            setcard3Data((prevData) => prevData.id === card3Data.id ? sliderData[6] : sliderData[4])
            setcard4Data((prevData) => prevData.id === card4Data.id ? sliderData[7] : sliderData[5])
        }, 2700


        );
        return () => clearInterval(interval);
    }, []);


    const handleRoute = () => {
        window.scrollTo(0, 0);
        navigate('/Services/whatWeDo')
    }




    const cardData = [
        {
            src: alrazi,
            alt: "Al-Razi",
            title: "Al-Razi",
            capacity: "Capacity: 15 to 25 Person"
        },
        {
            src: alFarabi,
            alt: "Al-Farabi",
            title: "Al-Farabi",
            capacity: "Capacity: 15 to 25 Person"
        },
        {
            src: alkhawarzmi,
            alt: "Al-Khwarizmi",
            title: "Al-Khwarizmi",
            capacity: "Capacity: 15 to 25 Person"
        },
        {
            src: alkindi,
            alt: "Al-Kindi",
            title: "Al-Kindi",
            capacity: "Capacity: 15 to 25 Person"
        }
    ];
    // const settings = {
    //     infinite: true,
    //     speed: 500,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     arrows: false,
    //     autoplay: true,
    //     autoplaySpeed: 3000,
    //     responsive: [
    //         {
    //             breakpoint: 1200,
    //             settings: {
    //                 slidesToShow: 2,
    //                 slidesToScroll: 1,
    //             },
    //         },
    //         {
    //             breakpoint: 768,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //             },
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //             },
    //         },
    //     ],
    // };
    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    const { modallg, gradientCircle, gradientCircleLeft, gradientCircleLeftTop, gradientCircleLeftTwo } = style;
    return (
        <>
            <TopNavbar />

            <div
                className="container-fluid py-4"
                style={{
                    backgroundImage: `url(${servicegradient})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    height: 'auto',
                    width: '100%',
                    backgroundPosition: 'top',
                    backgroundColor: '#D5D0EF'
                }}
            >
                <div className="row mt-5">
                    <div
                        className="py-5 container-fluid mb-md-4"
                        style={{
                            position: 'relative',
                            backgroundImage: `url(${serviceBanner})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            height: 'auto',
                            width: '84.6%',
                            borderRadius: '50px',
                        }}
                    >
                        {/* <img src={serviceBanner} className='container-fluid ' alt="" srcset="" /> */}
                        <div
                        ></div>
                        <div className="invisible d-flex flex-column justify-content-center align-items-center py-5 my-5 text-center" style={{ position: 'relative' }}>
                            <h2 className="font-weight-bold text-white pt-5 mt-5">The Trusted Venue Partner for all your Corporate
                                Events & Conferences</h2>
                            <h6 className="text-white mt-3">No matter if it’s a 10-person strategy meeting or a
                                1000-person conference, we’ve got your back.</h6>
                            <button className="slider_btn" data-toggle="modal" data-target="#bookingModal">Book Now</button>
                        </div>
                        <div className="pb-5 mb-5"></div>
                    </div>
                </div>

                <div className="row justify-content-center mt-md-5">
                    <div className="col-11">
                        <div className="row pb-5 px-4">

                            <Fade left>
                                <div
                                    className="col-lg-5  p-0 pl-sm-4 col-md-6 col-sm-12 pr-4">
                                    <img src={WeD6} alt="Wed2" className="img-container w-100 pr-sm-3 " />
                                </div>
                            </Fade>
                            <Fade right>
                                <div className="pl-xxl-4 col-lg-7 p-0 col-md-6 col-sm-12 pb-4 pb-lg-0  ">
                                    <h1 className="pl-sm-2 " style={{ fontWeight: 500, fontSize: "5.4rem", fontFamily: "Barlow,sans-serif", textAlign: 'left' }}>  <span style={{ color: '#160A54', fontFamily: "Barlow,sans-serif" }}>What  </span><span style={{ color: '#04642D' }}> We Offer</span></h1>
                                    <div className="row mt-3 font20 align-items-center pl-sm-2">
                                        <div className="col-12">
                                            <p className='mb-5  mt-3 pl-3 font21' style={{ color: '#5b5656', fontWeight: 500 }}> At Talent Expertz, we deliver flexible, customized HR solutions that meet the unique needs of your business and help drive sustainable growth.</p>

                                        </div>
                                        <div className="col-md-6 d-flex mb-4 align-items-center">
                                            <div className="col-1"><i className="fa-regular fa-circle-check mr-4  pl-sm-2" style={{ fontWeight: 300, fontSize: 40, color: '#160A54' }}></i></div>
                                            <div className="col-11"><p style={{ fontWeight: 400, color: '#3F3F3F', fontFamily: "Barlow,sans-serif", }} className=" font-weight-bold font21 pl-4"> Tailored Recruitment</p></div>
                                        </div>
                                        <div className="col-md-6 d-flex mb-4 align-items-center">
                                            <div className="col-1"><i className="fa-regular fa-circle-check mr-4  pl-sm-2" style={{ fontWeight: '200 !important', fontSize: 40, color: '#160A54' }}></i></div>
                                            <div className="col-11"><p style={{ fontWeight: 400, color: '#3F3F3F', fontFamily: "Barlow,sans-serif", }} className=" font-weight-bold font21 pl-4 ">Leadership Development</p></div>
                                        </div>
                                        <div className="col-md-6 d-flex mb-4 align-items-center">
                                            <div className="col-1"><i className="fa-regular fa-circle-check mr-4  pl-sm-2" style={{ fontWeight: '200 !important', fontSize: 40, color: '#160A54' }}></i></div>
                                            <div className="col-11">
                                                <p style={{ fontWeight: 400, color: '#3F3F3F', fontFamily: "Barlow,sans-serif", }} className=" font-weight-bold font21 pl-4 ">Skill Enhancement</p>

                                            </div>
                                        </div>

                                        <div className="col-md-6 d-flex mb-4 align-items-center">
                                            <div className="col-1"><i className="fa-regular fa-circle-check mr-4  pl-sm-2" style={{ fontWeight: '200 !important', fontSize: 40, color: '#160A54' }}></i></div>
                                            <div className="col-11">
                                                <p style={{ fontWeight: 400, color: '#3F3F3F', fontFamily: "Barlow,sans-serif", }} className=" font-weight-bold font21 pl-4 ">Compliance Assurance</p>

                                            </div>
                                        </div>    <div className="col-md-6 d-flex mb-4 align-items-center">
                                            <div className="col-1"><i className="fa-regular fa-circle-check mr-4  pl-sm-2" style={{ fontWeight: '200 !important', fontSize: 40, color: '#160A54' }}></i></div>
                                            <div className="col-11">
                                                <p style={{ fontWeight: 400, color: '#3F3F3F', fontFamily: "Barlow,sans-serif", }} className=" font-weight-bold font21 pl-4 ">Strategic Consulting</p>

                                            </div>
                                        </div>    <div className="col-md-6 d-flex mb-4 align-items-center">
                                            <div className="col-1"><i className="fa-regular fa-circle-check mr-4  pl-sm-2" style={{ fontWeight: '200 !important', fontSize: 40, color: '#160A54' }}></i></div>
                                            <div className="col-11">
                                                <p style={{ fontWeight: 400, color: '#3F3F3F', fontFamily: "Barlow,sans-serif", }} className=" font-weight-bold font21 pl-4 ">Inclusive Culture</p>
                                            </div>
                                        </div>
                                    </div>



                                </div>
                            </Fade>

                        </div>
                    </div>
                </div>
            </div>


            <div className="">
                <div
                    className="container-fluid py-4"
                    style={{
                        backgroundColor: "#FFF9F0",
                        backgroundImage: `url(${serviceWave})`,
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        position: "relative",
                        backgroundPosition: "center",
                    }}
                >
                    <div className="row d-flex justify-content-center align-items-center pb-sm-4">
                        <div className="col-lg-12 col-md-8 col-sm-12 d-flex flex-column justify-content-center align-items-center text-center text-white">
                            <h1
                                className="pb-4 pb-lg-0"
                                id="our_services"
                                style={{
                                    fontSize: "2rem", // Smaller font for better fit
                                }}
                            >
                                Our&nbsp;
                                <span
                                    id="our_services"
                                    style={{
                                        color: "#04642D",
                                        fontFamily: "Barlow, sans-serif",
                                        fontSize: "2rem", // Matches heading size
                                    }}
                                    className="green_underline"
                                >
                                    Services
                                </span>
                            </h1>
                            <h6
                                className="col-lg-8 col-md-12 pt-2 mt-4 px-4"
                                id="our_services_paragraph"
                                style={{
                                    fontSize: "0.9rem", // Slightly smaller font
                                    lineHeight: "1.5rem", // Adjust line height for readability
                                }}
                            >
                                Talent Expertz (TE) goes beyond quick fixes, providing meticulously
                                tailored, accessible HR solutions for lasting impact. Our services
                                include
                            </h6>
                        </div>
                    </div>

                    {/* Computer View */}
                    <div
                        className="row justify-content-center align-items-center py-4 d-flex mx-sm-5 p-0 ml-4 ml-sm-0"
                        style={{ gap: "50px", flexWrap: "wrap" }}
                    >
                        {services.map((service, index) => (
                            <div
                                key={index}
                                className="col-lg-3 mb-sm-0 col-md-3 col-sm-10 d-flex justify-content-start align-items-start p-0"
                                onClick={handleRoute}
                            >
                                <div
                                    className="bg-white d-flex flex-column justify-content-start align-items-start text-start text-black p-3"
                                    style={{
                                        borderRadius: "18px",
                                        boxShadow: "18px 15px 35px 0 rgba(22, 10, 84, 0.15)",
                                        cursor: "pointer",
                                    }}
                                >
                                    <div className="col-md-6 col-lg-5 p-0 pt-3">
                                        <img
                                            src={service.imgSrc}
                                            alt=""
                                            id="services_card_img"
                                            style={{
                                                width: "100%", // Ensure the image is responsive
                                                height: "auto",
                                            }}
                                        />
                                    </div>
                                    <h5
                                        className="mb-2 mt-1"
                                        id="services_card_title"
                                        style={{
                                            fontSize: "1rem", // Slightly smaller heading
                                        }}
                                    >
                                        {service.title}
                                    </h5>
                                    <p
                                        className="col-md-11 col-lg-11 line-height-sm p-0"
                                        id="services_card_desc"
                                        style={{
                                            fontSize: "0.85rem", // Slightly smaller paragraph text
                                            lineHeight: "1.4rem",
                                        }}
                                    >
                                        {service.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div
                        className="col-12 justify-content-center align-items-center py-4 d-none d-md-flex d-lg-flex mx-5 p-0"
                        style={{ gap: "50px" }}
                    ></div>
                </div>


                <div className="container-fluid py-4 "
                    style={{
                        backgroundColor: '#D5D0EF',
                        backgroundImage: `url(${randomline})`,
                        backgroundSize: 'cover ',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                        position: 'relative',
                        // zIndex:-1,
                        backgroundPosition: ' center'
                    }}
                >

                    <div className="row d-flex justify-content-center align-items-center pb-sm-4 my-sm-5">
                        <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center text-white pl-sm-5">
                            <h1 className="pb-4 pb-lg-0 pl" id="our_services1" >See What They’re Saying About&nbsp;<span id="our_services1" style={{ color: "#04642D", fontFamily: "Barlow,sans-serif", }} className='green_underline'>Talent Expertz</span></h1>

                        </div>
                        <h6 className="col-lg-7 col-md-12 pt-2 mt-2 pl-5 pr-5 text-center " id='our_services_paragraph1'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus hendrerit suscipit egestas. Nunc eget congue ante. Vivamus ut sapien et ex volutpat tincidunt eget at felis.
                        </h6>

                    </div>


                    <div className="row justify-content-center">
                        <div className="col-10">
                            <div className=" d-flex mt-3 " style={{ marginTop: "100px !important", flexWrap: 'wrap' }}>
                                {/* <SliderWrapper>
        <Slider {...settings}> */}
                                {/* {data.map((card, index) => (
                                <Card className='col-lg-5 mb-4' key={index}>
                                    <div className="card-body px-sm-5 px-3 p-0">

                                        <div className="" style={{ position: 'absolute', width: 100, height: 100, top: "22%", left: "-10%" }}>
                                            <img
                                                src={card.imgSrc}
                                                alt={card.name}
                                                className="rounded-circle custom-img "
                                                style={{ width: "100%", height: 'auto' }}
                                            />
                                        </div>
                                        <p className="card-text mb-3 mt-3 font12 testi_Card_text">{card.text}</p>
                                        <div className="row justify-content-between mt-3">
                                            <div className="col" >
                                                <h5 className="font-weight-bolder">{card.name}</h5>
                                                <h6 className="">{card.title}</h6>
                                            </div>
                                            <div className="col" style={{ display: 'contents' }}>
                                                <Rating>
                                                    {[...Array(card.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star rating"></i>
                                                    ))}
                                                    {[...Array(5 - card.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star disable_rating"></i>
                                                    ))}
                                                </Rating>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            ))} */}
                                {/* </Slider>
      </SliderWrapper> */}


                                <Card className='col-lg-5 mb-4'>
                                    <div className="card-body px-sm-5 px-3 p-0" >

                                        <div className="" style={{ position: 'absolute', width: 100, height: 100, top: "22%", left: "-10%" }}>
                                            <img
                                                src={card1Data.imgSrc}
                                                className="rounded-circle custom-img "
                                                style={{ width: "100%", height: 'auto' }}
                                            />
                                        </div>
                                        <p className="card-text mb-3 mt-3 font12 testi_Card_text">{card1Data.text}</p>
                                        <div className="row justify-content-between mt-3">
                                            <div className="col" >
                                                <div data-aos="flip-up">
                                                    <h5 className="font-weight-bolder">{card1Data.name}</h5>

                                                </div>
                                                <h6 className="text-left">{card1Data.title}</h6>
                                            </div>
                                            <div className="col" style={{ display: 'contents' }}>
                                                <Rating>
                                                    {[...Array(card1Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star rating"></i>
                                                    ))}
                                                    {[...Array(5 - card1Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star disable_rating"></i>
                                                    ))}
                                                </Rating>
                                            </div>
                                        </div>
                                    </div>
                                </Card>


                                <Card className='col-lg-5 mb-4'>
                                    <div className="card-body px-sm-5 px-3 p-0">

                                        <div className="" style={{ position: 'absolute', width: 100, height: 100, top: "22%", left: "-10%" }}>
                                            <img
                                                src={card2Data.imgSrc}
                                                className="rounded-circle custom-img "
                                                style={{ width: "100%", height: 'auto' }}
                                            />
                                        </div>
                                        <p className="card-text mb-3 mt-3 font12 testi_Card_text">{card2Data.text}</p>
                                        <div className="row justify-content-between mt-3">
                                            <div className="col" >
                                                <div data-aos="flip-up">
                                                    <h5 className="font-weight-bolder">{card2Data.name}</h5>

                                                </div>
                                                <h6 className="text-left">{card2Data.title}</h6>
                                            </div>
                                            <div className="col" style={{ display: 'contents' }}>
                                                <Rating>
                                                    {[...Array(card2Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star rating"></i>
                                                    ))}
                                                    {[...Array(5 - card2Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star disable_rating"></i>
                                                    ))}
                                                </Rating>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                                <Card className='col-lg-5 mb-4'>
                                    <div className="card-body px-sm-5 px-3 p-0">

                                        <div className="" style={{ position: 'absolute', width: 100, height: 100, top: "22%", left: "-10%" }}>
                                            <img
                                                src={card3Data.imgSrc}
                                                className="rounded-circle custom-img "
                                                style={{ width: "100%", height: 'auto' }}
                                            />
                                        </div>
                                        <p className="card-text mb-3 mt-3 font12 testi_Card_text">{card3Data.text}</p>
                                        <div className="row justify-content-between mt-3">
                                            <div className="col" >
                                                <div data-aos="flip-up">
                                                    <h5 className="font-weight-bolder">{card3Data.name}</h5>

                                                </div>
                                                <h6 className="text-left">{card3Data.title}</h6>
                                            </div>
                                            <div className="col " style={{ display: 'contents' }}>
                                                <Rating>
                                                    {[...Array(card3Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star rating"></i>
                                                    ))}
                                                    {[...Array(5 - card3Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star disable_rating"></i>
                                                    ))}
                                                </Rating>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                                <Card className='col-lg-5 mb-4'>
                                    <div className="card-body px-sm-5 px-3 p-0">

                                        <div className="" style={{ position: 'absolute', width: 100, height: 100, top: "22%", left: "-10%" }}>
                                            <img
                                                src={card4Data.imgSrc}
                                                className="rounded-circle custom-img "
                                                style={{ width: "100%", height: 'auto' }}
                                            />
                                        </div>
                                        <p className="card-text mb-3 mt-3 font12 testi_Card_text">{card4Data.text}</p>
                                        <div className="row justify-content-between mt-3">
                                            <div className="col" >
                                                <div data-aos="flip-up">
                                                    <h5 className="font-weight-bolder">{card4Data.name}</h5>

                                                </div>
                                                <h6 className="text-left">{card4Data.title}</h6>
                                            </div>
                                            <div className="col" style={{ display: 'contents' }}>
                                                <Rating>
                                                    {[...Array(card4Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star rating"></i>
                                                    ))}
                                                    {[...Array(5 - card4Data.rating)].map((_, i) => (
                                                        <i key={i} className="fa-solid fa-star disable_rating"></i>
                                                    ))}
                                                </Rating>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>

                        </div>
                    </div>


                </div>

            </div>

            <Footer />
        </>
    );
}


const SliderWrapper = styled.div`
  .slick-slide {
    position: relative;
    text-align: center;
    border-radius: 25px !important;
  }

  img {
    width: 100%;
    height: auto;
    /* border-radius: 25px !important; */
  }

  .info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    /* padding: 10px; */
    transition: opacity 0.3s ease;
  }

  .overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 93%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    transform: translate(-50%, -50%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    border-radius: 25px !important;
  }

  .slick-slide:hover .info {
    opacity: 0;
  }

  .slick-slide:hover .overlay {
    opacity: 1;
  }

  
`;
const Rating = styled.div`
  .rating {
    color: #FFCF59 !important;
    text-align: end !important;
  }
  .disable_rating {
    color: grey !important;
  }
`;

const Card = styled.div`
  width: 16rem;
  margin: 0 auto;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 10px;

  a {
    color: inherit; /* Initial color */
    transition: color 0.3s ease; /* Smooth transition on hover */

    &:hover {
      color: #0077b5; /* LinkedIn blue */
    }
  }

  .card {
    width: 100%;
    margin: 0 10px;
  }
`;